<div class="d-flex flex-column min-vh-100">
    <app-header-buscador></app-header-buscador>

    <div class="container-fluid">

        <div class="text-center">
            <img [src]="url+config?.us" alt="Sobre nosotros" class="img-fluid">
        </div>

    </div>

    <app-footer class="mt-auto"></app-footer>
</div>